import React from 'react';
import { ICONS } from './svg';
import { IIconSVG } from './types';
import { useStyletron } from 'baseui';

type SVGProps = React.ComponentProps<'svg'>;

export const Icon = (props: IIconSVG & React.ComponentProps<'svg'>) => {
	const { size = '20px', color = 'var(--epods--color-text-ds-dark)', for: _for, icon, ...rest } = props;
	const [css] = useStyletron();
	const styles = {
		svg: {
			display: 'inline-block',
			verticalAlign: props.for === 'checkboxInset' ? 'top' : 'middle',
			transform: 'rotate(180deg) scaleX(-1)',
			minWidth: size,
			minHeight: size,
			width: size,
			height: size,
			padding: '0',
		},
		path: {
			fill: color,
		},
	};

	const nonMaterialIcons = ['settings', 'filter', 'expand', 'collapsed'];
	const viewBoxSize = nonMaterialIcons.includes(icon) ? '75 0 850 850' : '0 0 500 500';

	return (
		<svg className={css(styles.svg)} viewBox={viewBoxSize} {...rest}>
			<path className={css(styles.path)} d={ICONS[icon]}></path>
		</svg>
	);
};
